export default __webpack_public_path__ + "static/media/Group 6500@3x.e306d92c.png";